const LEAD_ID_KEY = 'openFundEarlyLeadId';
const LEAD_TOKEN_KEY = 'openFundEarlyLeadToken';

export interface StoredOpenFundEarlyLead {
  leadId: string;
  resumeToken: string;
}

export function readStoredOpenFundEarlyLead(): StoredOpenFundEarlyLead | null {
  const leadId = localStorage.getItem(LEAD_ID_KEY);
  const resumeToken = localStorage.getItem(LEAD_TOKEN_KEY);
  if (!leadId || !resumeToken) return null;
  return { leadId, resumeToken };
}

export function writeStoredOpenFundEarlyLead(lead: StoredOpenFundEarlyLead): void {
  localStorage.setItem(LEAD_ID_KEY, lead.leadId);
  localStorage.setItem(LEAD_TOKEN_KEY, lead.resumeToken);
}

export function clearStoredOpenFundEarlyLead(): void {
  localStorage.removeItem(LEAD_ID_KEY);
  localStorage.removeItem(LEAD_TOKEN_KEY);
}
